@if (spec) {
    <div class="lm-builder-display-fields-container">
        @if (_showDetail()) {
            <div class="lm-builder-display-fields-toolbar">
                <a soho-hyperlink="back-caret" data-automation-id="lm-builder-display-fields-back-btn" (click)="hideDetail()">
                    <svg soho-icon class="lm-builder-display-field-icon" [icon]="'caret-left'" soho-tooltip [content]="'Back' | translate"/>
                </a>
            </div>
            @if (_selectedDisplayField()) {
                <lm-builder-display-field [spec]="spec" [displayField]="_selectedDisplayField()" [fieldSpec]="_selectedDisplayField().type === 'field' ? _selectedDisplayField().spec : undefined" ]></lm-builder-display-field>
            } @else if (spec.cardView) {
                <div class="lm-builder-display-fields-list-container">
                    <div class="field">
                        <label soho-label for="lm-display-field-card-view">{{ 'CardView' | translate }}</label>
                        <input
                                id="lm-display-field-card-view"
                                data-automation-id="lm-display-field-card-view-input"
                                soho-input
                                soho-trackdirty
                                readonly=" true"
                                [(ngModel)]="spec.cardView.name">
                    </div>
                </div>
            }

        } @else {
            @if (spec?.cardView) {
                <div class="lm-builder-display-fields-list-container">
                    @if (spec?.displayFields?.length > 0){
                        <svg soho-icon class="lm-builder-icon" [icon]="'drag'" soho-tooltip [content]="'CardViewIsFirstColumn' | translate" data-automation-id="lm-builder-display-fields-card-drag-icon"/>
                    }
                    <div class="lm-builder-display-field-label">
                        <p>{{ spec.cardView.name }}</p>
                        <div>
                            <a (click)="showCardDetail()">
                                <svg [id]="'lm-builder-card-view-edit-icon'" [attr.data-automation-id]="'lm-builder-card-view-edit-icon'" class="lm-builder-display-field-hover-icon" soho-icon [icon]="'caret-right'" soho-tooltip [content]="'Edit' | translate"/>
                            </a>
                        </div>
                    </div>
                </div>
            }
            <div
                    class="lm-builder-display-field-boundary"
                    cdkDropList
                    [id]="LMBuilderModel.DISPLAY_FIELDS_LIST"
                    [cdkDropListConnectedTo]="[LMBuilderModel.FACADE_FIELD_PICKER_FIELDS_LIST, LMBuilderModel.DISPLAY_FIELDS_LIST]"
                    [cdkDropListData]="LMBuilderModel.DISPLAY_FIELDS_LIST"
                    [cdkDropListEnterPredicate]="canDrop"
                    (cdkDropListDropped)="drop($event)">
                @if (spec?.displayFields?.length > 0)   {
                    @for (df of spec?.displayFields; track df ) {
                        <div cdkDragBoundary=".lm-builder-display-field-boundary" cdkDrag [cdkDragData]="df" class="lm-builder-display-fields-list-container">
                            <div *cdkDragPreview class="lm-builder-display-fields-list-container">
                                <svg cdkDragHandle soho-icon class="lm-builder-icon" [icon]="'drag'" soho-tooltip [content]="'DragMe' | translate"/>
                                <div><p>{{df.type === 'field' ? df.spec.fieldId : df.type }}</p></div>
                            </div>
                            <svg cdkDragHandle soho-icon class="lm-builder-icon" [icon]="'drag'" soho-tooltip [content]="'DragMe' | translate"  [attr.data-automation-id]="'lm-builder-display-field-' + $index + '-drag-icon'"/>
                            <div class="lm-builder-display-field-label">
                                <p soho-tooltip [content]="df.spec?.fieldId"  [attr.data-automation-id]="'lm-builder-display-field-' + $index + '-text'">{{df.type === 'field' ? df.label.display.trim().length > 0 ? df.label.display : df.spec.fieldId : df.type }}</p>
                                <div>
                                    @if (df.type === 'field') {
                                        @if (spec.implementsColumnarView) {
                                            @if (df.spec.sort?.default) {
                                                <svg [id]="'lm-builder-display-field' + $index + '-default-sort-icon'" [attr.data-automation-id]="'lm-builder-display-field-' + $index + '-default-sort-icon'" class="lm-builder-display-field-icon default-sort"  soho-icon [icon]="'sort'" soho-tooltip [content]="'Default sort. Sorted by ' + df.spec.fieldId"/>
                                            } @else {
                                                <svg [id]="'lm-builder-display-field' + $index + '-sort-icon'" [attr.data-automation-id]="'lm-builder-display-field-' + $index + '-sort-icon'" class="lm-builder-display-field-icon"  soho-icon [icon]="'sort'" soho-tooltip [content]="'Sorted by ' + df.spec.fieldId"/>
                                            }
                                        } @else {
                                            @if (df.spec.sort) {
                                                @if (df.spec.sort.default) {
                                                    <svg [id]="'lm-builder-display-field' + $index + '-default-sort-icon'" [attr.data-automation-id]="'lm-builder-display-field-' + $index + '-default-sort-icon'" class="lm-builder-display-field-icon default-sort"  soho-icon [icon]="'sort'" soho-tooltip [content]="'Default sort. Sorted by ' + df.spec.sort.name"/>
                                                } @else {
                                                    <svg [id]="'lm-builder-display-field' + $index + '-sort-icon'" [attr.data-automation-id]="'lm-builder-display-field-' + $index + '-sort-icon'" class="lm-builder-display-field-icon"  soho-icon [icon]="'sort'" soho-tooltip [content]="'Sorted by ' + df.spec.sort.name"/>
                                                }
                                            }
                                        }
                                    }
                                    <a (click)="removeDisplayField($index, df)">
                                        <svg [id]="'lm-builder-display-field' + $index + '-remove-icon'" [attr.data-automation-id]="'lm-builder-display-field-' + $index + '-remove-icon'" class="lm-builder-display-field-hover-icon" soho-icon [icon]="'close-small'" soho-tooltip [content]="'Remove' | translate"/>
                                    </a>
                                    <a (click)="showDetail(df)">
                                        <svg [id]="'lm-builder-display-field' + $index + '-edit-icon'" [attr.data-automation-id]="'lm-builder-display-field-' + $index + '-edit-icon'" class="lm-builder-display-field-hover-icon" soho-icon [icon]="'caret-right'" soho-tooltip [content]="'Edit' | translate"/>
                                    </a>
                                </div>
                            </div>
                        </div>
                    }
                    <div class="empty-title" soho-emptymessage
                         [info]="'AddFieldsByDraggingMessage' | translate">
                    </div>
                } @else {
                    <div class="empty-title" soho-emptymessage
                         [icon]="'icon-empty-no-analytics-new'"
                         [title]="'AddColumnsToYourReport' | translate"
                         [info]="'AddFieldsByDraggingMessage' | translate">
                    </div>
                 }
            </div>
            <div class="lm-builder-display-fields-add">
                <button soho-button="secondary" (click)="addComputeDisplayField()" data-automation-id="lm-builder-display-field-add-btn">{{ 'AddCompute' | translate }}</button>
            </div>
        }
    </div>
}


